module.exports = {
  GITHUB_LINK: "https://github.com/incr3m/activity-pwa"
};
